import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link, Redirect } from 'react-router-dom'
import { Col, Button, Form, FormGroup, Input, Alert } from 'reactstrap';

import { loginUser } from '../../actions/userActions'

class SingIn extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    let { loginUser } = this.props
    let data = new FormData(document.querySelector('#login-form'));

    loginUser(data);
  }

  render() {
    let { login } = this.props.userState

    return (
      <Form onSubmit={this.handleSubmit} id="login-form" style={{ "maxWidth": 410 }} className="mx-auto">
        {login.isLogin ? <Redirect to='/' /> : null}
        <h2 className="text-center mb-4">Se connecter</h2>
        <FormGroup className="d-flex">
            <Input type="email" name="email" id="inputEmail" placeholder="E-mail ..." required />
            <i className="fas fa-user fa-username"></i>
        </FormGroup>
        <FormGroup className="d-flex">
          <Input type="password" name="passwd" id="inputPassword" placeholder="Mot de passe ..." required />
          <i className="fas fa-key fa-keyword"></i>
        </FormGroup>
        <FormGroup check row>
          <Col sm={{ size: 12 }} className="text-center ">
            <Button type="submit" color="primary" className="w-100 my-4">Connexion</Button>
          </Col>
        </FormGroup>
        {login.message.show ?
          <Alert color="warning" className="mt-4">
            {login.message.text}
          </Alert>
          : null
        }
        <div className="form-group row px-3 mt-2">
            <Link to="forgot-password" id="forgot-password-link" className="col-xs-6 col-lg-6 text-left">
							Mot de passe oublié
            </Link>
						<Link to="registration" id="forgot-registre-link" className="col-xs-6 col-lg-6 text-right">
              Inscrivez-vous
            </Link>
					</div>
      </Form>
    );
  }
}


function mapStateToProps({ userReducer }) {
  return {
    userState: userReducer
  }
}
function mapDispatchToProps(dispatch) {
  return {
    loginUser: bindActionCreators(loginUser, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SingIn);


// WEBPACK FOOTER //
// ./src/containers/User/SingIn.js